import { FC, Dispatch, SetStateAction } from "react";

interface ICIOCollapsables {
  task_areas: boolean;
  documents: boolean;
}

interface IProps {
  isCollapsed: ICIOCollapsables;
  setIsCollapsed: Dispatch<SetStateAction<ICIOCollapsables>>;
}

export const TaskAreas: FC<IProps> = ({ isCollapsed, setIsCollapsed }) => {
  return (
    <div className="Contract__wrapper__section">
      <h2
        onClick={() =>
          setIsCollapsed({
            ...isCollapsed,
            task_areas: !isCollapsed.task_areas,
          })
        }
        className="collapsable"
      >
        Task Areas
        <i
          className={
            isCollapsed.task_areas ? "fas fa-caret-down" : "fas fa-caret-up"
          }
        ></i>
      </h2>
      <div
        className={`Contract__wrapper__section__content ${
          isCollapsed.task_areas ? "hidden" : ""
        }`}
      >
        <div className="collapse-wrapper">
          <button
            onClick={() =>
              setIsCollapsed({
                ...isCollapsed,
                task_areas: true,
              })
            }
            className="collapse-section"
          >
            Collapse section
          </button>
        </div>
        <ul className="task-area-list">
          <li>
            1: IT Services for Biomedical Research, Health Sciences, and
            Healthcare
          </li>
          <li>4: Outsourcing</li>
          <li>5: IT Operations and Maintenance</li>
          <li>6: Integration Services</li>
          <li>
            7: Critical Infrastructure Protection and Information Assurance
          </li>
          <li>10: Software Development</li>
        </ul>
        <small>
          Please visit our{" "}
          <a
            href="https://nitaac.nih.gov/services/contract-holder/professional-software-engineering-inc"
            target="_blank"
            rel="noopener noreferrer"
            className="color-blue"
          >
            NITAAC.gov
          </a>{" "}
          page for more details and the list of Task Areas.
        </small>
      </div>
    </div>
  );
};
